import { Mascot } from '@/components/shared'
import { Button } from '@/components/ui/button'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { useOrganizationStore } from '@/store/organization.store'
import { Link, useNavigate } from 'react-router-dom'

export default function NotFoundPage() {
  const organization = useOrganizationStore(state => state.currentOrganization)
  const navigate = useNavigate()
  useDocumentTitle('Page not found')
  // A link followed from inside the app can go back to where it was; a URL
  // opened fresh has nowhere to go back to.
  const canGoBack = window.history.length > 1

  return (
    <div className="flex-1 overflow-auto">
      <div className="flex min-h-[calc(100vh-3.5rem)] flex-col items-center justify-center bg-background p-4 text-foreground">
        <div className="flex max-w-sm flex-col items-center text-center">
          <Mascot variant="not-found" size="lg" className="mb-8" />
          <p className="mb-1 text-sm font-medium tabular-nums text-muted-foreground">
            404
          </p>
          <h1 className="mb-2 text-2xl font-semibold text-foreground">
            Page not found
          </h1>
          <p className="mb-6 text-sm text-muted-foreground">
            The link may be broken, or the page may have moved.
          </p>
          <div className="flex items-center gap-2">
            {canGoBack && (
              <Button variant="outline" onClick={() => navigate(-1)}>
                Go back
              </Button>
            )}
            {/* asChild: one link, not a button nested inside a link. */}
            <Button asChild>
              <Link to={organization?.slug ? `/${organization.slug}` : '/'}>
                Go home
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
